import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserProvider } from '../../providers/user';
import {TeamappProvider} from "../../providers/teamapp";
import {DataProvider} from "../../providers/data";
import {InAppBrowser} from "@ionic-native/in-app-browser";

import * as moment from "moment";
import {NewsReadPage} from "../news-read/news-read";
import {JobsPage} from "../jobs/jobs";
import {MagazinePage} from "../magazine/magazine";
/**
 * Generated class for the GuestdashboardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-guestdashboard',
  templateUrl: 'guestdashboard.html',
})
export class GuestdashboardPage {

  dashboard: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider, public dataProvider: DataProvider, private iab: InAppBrowser) {
      this.teamappProvider.http_request('', 'guest', false, true).then(data => {
          this.dashboard = data;
          console.log(data);
      });
  }

    formatNewsDate(date: any) {
        return moment(date).format('DD.MM.YYYY');
    }

  getLoadDate() {
      return moment().format('D.MM.YYYY');
  }

  openNews(news: any) {
      if(news.type == 'rss') {
          this.iab.create(news.link, '_blank');
      } else if(news.type == 'own') {
          this.navCtrl.push(NewsReadPage, {news: news});
      }
  }

  openJobs() {
    this.navCtrl.push(JobsPage);
  }

    openPage(id: number, title: string) {
        this.navCtrl.push(MagazinePage, {page: id, title: title});
    }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GuestdashboardPage');
  }


}



// WEBPACK FOOTER //
// ./src/pages/guestdashboard/guestdashboard.ts